export default "__VITE_ASSET__Dryg5rD3__"